import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75129ca7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home-main"
}
const _hoisted_2 = { class: "home-main-box" }
const _hoisted_3 = { class: "home-TUIKit" }
const _hoisted_4 = { class: "home-TUIKit-main" }
const _hoisted_5 = { class: "conversation" }
const _hoisted_6 = { class: "chat" }
const _hoisted_7 = {
  key: 0,
  class: "chat-default"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://image.iguopin.com/public/no-message.png" }, null, -1))
const _hoisted_9 = { class: "chat-default-right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chat-default-text" }, "暂时没有新消息", -1))
const _hoisted_11 = {
  key: 1,
  class: "home-h5-main"
}
const _hoisted_12 = { class: "message" }
const _hoisted_13 = { class: "home-h5-content" }
const _hoisted_14 = { class: "home-h5-main-header" }
const _hoisted_15 = { class: "home-h5-main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUISearch = _resolveComponent("TUISearch")!
  const _component_TUIConversation = _resolveComponent("TUIConversation")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TUIChat = _resolveComponent("TUIChat")!
  const _component_tab_bar = _resolveComponent("tab-bar")!
  const _component_TUICallKit = _resolveComponent("TUICallKit")!
  const _component_Drag = _resolveComponent("Drag")!
  const _component_TUICallKitMini = _resolveComponent("TUICallKitMini")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.env.isH5)
      ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_TUISearch),
                  _createVNode(_component_TUIConversation, {
                    onCurrent: _ctx.handleCurrentConversation,
                    displayOnlineStatus: _ctx.displayOnlineStatus
                  }, null, 8, ["onCurrent", "displayOnlineStatus"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_TUIChat, {
                    isMsgNeedReadReceipt: _ctx.isMsgNeedReadReceipt,
                    isNeedTyping: true,
                    isNeedEmojiReact: true
                  }, {
                    default: _withCtx(() => [
                      (_ctx.conversationLen === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("div", _hoisted_9, [
                              _hoisted_10,
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _ctx.toHome
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("返回国聘首页")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["isMsgNeedReadReceipt"])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("main", _hoisted_11, [
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("main", _hoisted_13, [
              _createElementVNode("header", _hoisted_14, [
                _createVNode(_component_TUISearch)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_TUIConversation, {
                  onCurrent: _ctx.handleCurrentConversation,
                  displayOnlineStatus: _ctx.displayOnlineStatus
                }, null, 8, ["onCurrent", "displayOnlineStatus"])
              ])
            ])
          ], 512), [
            [_vShow, !_ctx.currentConversationID]
          ]),
          _withDirectives(_createVNode(_component_TUIChat, {
            isMsgNeedReadReceipt: _ctx.isMsgNeedReadReceipt,
            isNeedTyping: true,
            isNeedEmojiReact: true
          }, null, 8, ["isMsgNeedReadReceipt"]), [
            [_vShow, _ctx.currentConversationID]
          ]),
          _withDirectives(_createVNode(_component_tab_bar, { active: "chat" }, null, 512), [
            [_vShow, !_ctx.currentConversationID && !_ctx.hideTabbar]
          ])
        ])),
    _createVNode(_component_Drag, {
      show: _ctx.showCall,
      class: _normalizeClass(["callkit-drag-container", [_ctx.env.isH5 && 'callkit-drag-container-H5', _ctx.menuStatus && 'callkit-drag-container-left']]),
      domClassName: "callkit-drag-container"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TUICallKit, {
          allowedMinimized: true,
          allowedFullScreen: false,
          beforeCalling: _ctx.beforeCalling,
          afterCalling: _ctx.afterCalling,
          onMinimized: _ctx.onMinimized,
          onMessageSentByMe: _ctx.onMessageSentByMe
        }, null, 8, ["beforeCalling", "afterCalling", "onMinimized", "onMessageSentByMe"])
      ]),
      _: 1
    }, 8, ["show", "class"]),
    _createVNode(_component_Drag, {
      show: _ctx.showCallMini,
      class: "callkit-drag-container-mini",
      domClassName: "callkit-drag-container-mini"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TUICallKitMini, { style: {"position":"static"} })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}